

















































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Company } from '@/store/modules/lib';

@Component
export default class ShCommonGroup extends Vue {

  @Prop({ type: Object, default: {} }) protected group!: any;

  // protected get title() {

    // return this.group.shards.length > 0 ? this.group.shards[0].company : null;

    // title: shard.target_type == 'company'
    //   ? shard.target.title
    //   : shard.target_type == 'badge'
    //     ? `${shard.target.name.last} ${shard.target.name.first}`
    //     : shard.target.title,
    // subtitle: shard.target_type == 'company'
    //   ? ''
    //   : shard.target_type == 'badge'
    //     ? shard.target.position
    //     : shard.target.vendorcode,

  // }


  // protected productSelected(productId: string) {
  //   this.$emit('productSelected', productId);
  // }

  // protected productRemove(productId: string) {
  //   this.$emit('productRemove', productId);
  // }

  // protected productEdit(productId: string) {
  //   this.$emit('productEdit', productId);
  // }

  // protected get sortedProducts() {

  //   return this.products.sort(function(a: Product, b: Product) {
  //     return a.title > b.title
  //       ? 1
  //       : (a.title < b.title)
  //         ? -1
  //         : 0;
  //   });

  // }

}

